import script from "./BillRoulette.vue?vue&type=script&setup=true&lang=js"
export * from "./BillRoulette.vue?vue&type=script&setup=true&lang=js"

import "./BillRoulette.vue?vue&type=style&index=0&id=4cf439ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf439ee"]])

export default __exports__